<template>
<div style="min-height: 100%;">
  <HeaderView></HeaderView>
  <BannerView></BannerView>
  <div v-bind:style="{minHeight: height+'px'}" style="width: 800px;margin: 0 auto;" >
    <el-steps style="padding-top:40px;width: 750px" :active="active" finish-status="success" align-center>
      <el-step title="账户密码重置"></el-step>
      <el-step title="重置结果通知"></el-step>
    </el-steps>
    <div v-if="active===0" class="register-wrapper-div">
      <el-form @submit.native.prevent style="width: 460px;margin: 0 auto;" label-position="right" label-width="150px" status-icon key="account" :rules="accountRules" :model="account" ref="account">
        <el-form-item label="账户名" prop="username">
          <el-input v-model="account.username" placeholder="由6到14位的中文、字母或数字组成" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱"  prop="email">
          <el-input v-model="account.email" placeholder="请输入电子邮箱" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="验证码"  prop="captcha">
          <el-input v-model="account.captcha" placeholder="请输入验证码" autocomplete="off" autocapitalize="off" spellcheck="false"></el-input>
        </el-form-item>
        <el-form-item>
          <img ref="captcha" style="width: 110px; height: 40px; float: left;" :src="captchaUrl" @click="changCaptcha"></img>
        </el-form-item>
      </el-form>

      <el-button :loading="submitButtonLoading" style="margin-top: 12px;" @click="goLogin">返回登录</el-button>
      <el-button :loading="submitButtonLoading" type="primary" style="margin-top: 12px;" @click="submitForm('account')">提&emsp;交</el-button>
    </div>
    <div v-if="active===1" class="register-wrapper-div">
      <el-row type="flex">
        <el-col :span="24">
        <span style="font-size: 75px;font-weight: bold; padding: 20px;line-height: 80px;">
          <i class="el-icon-success" style="color:#52C41A;"></i>
        </span>
        </el-col>
      </el-row>
      <div style="font-size: 24px;color: #333;font-weight: 500;margin-top: 30px;">
        密码重置提交成功
      </div>
      <div style="font-size: 14px;color: #666;margin-top: 20px;">请至电子邮箱查收！</div>
      <el-button :loading="submitButtonLoading" style="margin-top: 50px;" @click="goLogin">返回登录</el-button>
    </div>
  </div>

  <FooterView></FooterView>

</div>

</template>

<script>
  export default {
    name: 'forgot-password',
    data(){
      //账户名
      var usernameUnique =(rule, value, callback) => {
        this.submitButtonLoading = true;
        this.$api.registerApi.usernameUnique2({'username':value}).then(response => {
          this.submitButtonLoading = false;
          if (response.status === 200) {
            if (response.data.code === 400) {
              callback();
            } else {
              callback(new Error(response.data.msg));
            }
          } else {
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      };
      //验证码
      var captchaUnique =(rule, value, callback) => {
        this.submitButtonLoading = true;
        this.$api.registerApi.captchaValidate({'captcha':value}).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              callback();
            }else{
              callback(new Error(response.data.data));
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      };
      return {
        active: 0,
        height: 0,
        submitButtonLoading: false,
        dialogImageVisible: false,
        dialogPdfVisible: false,
        dialogImageUrl: '',
        dialogPdfUrl: null,
        pdfPage : 1,
        pageCount: 0,
        captchaUrl: '',
        account: {
          username: '', //账户名
          email: '', //电子邮箱
          captcha: '' //验证码
        },
        accountRules: {
          username: [//远程校验唯一
            { required: true, message: '账户名由6到14位的中文字符、英文字母、数字组成', trigger: 'blur' },
            { min: 6, max: 14, message: '账户名由6到14位的中文字符、英文字母、数字组成', trigger: 'blur' },
            {
              pattern: /(^[a-zA-Z0-9_\u4e00-\u9fa5]+$)/,
              message: "账户名由6到14位的中文字符、英文字母、数字组成"
            },
            { validator:usernameUnique, message: '当前账户名不存在', trigger: 'blur' }
          ],
          email: [
            { required: true, message: '请输入电子邮箱', trigger: 'blur' },
            { min: 0, max: 255, message: '最大255位', trigger: 'blur' },
            {
              pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
              message: "请输入正确的电子邮箱"
            }
          ],
          captcha: [
            { required: true, message: '请输入验证码', trigger: 'blur' }
          ],
        },
      };
    },
    mounted(){
      //动态设置内容高度 让footer始终居底   header+footer的高度是100
      this.height = document.documentElement.clientHeight - 350;
      //监听浏览器窗口变化　
      window.onresize = ()=> {this.height = document.documentElement.clientHeight - 350}
    },
    created() {
      this.captchaUrl = this.getCaptchaUrl();
    },
    watch:{
    },
    methods: {
      changCaptcha: function() {
        this.captchaUrl = this.getCaptchaUrl();
      },
      getCaptchaUrl: function() {
        this.account.captcha = '';
        return process.env.VUE_APP_API_URL+'captcha.svl?d='+new Date().getTime()
      },
      next(formName) {
        this.submitButtonLoading = true;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitButtonLoading =  false;
            if (this.active++ > 4) this.active = 0;
          } else {
            this.submitButtonLoading =  false;
            return false;
          }
        });
      },
      submitForm(formName) {
        this.submitButtonLoading = true;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log(this.account,this.companyInfo,this.qyzzUpload);
            var json3={};
            Object.assign(json3, this.account);
            this.$api.registerApi.forgotPassword(json3).then(response => {
              this.submitButtonLoading = false;
              console.log(response);
              if(response.status === 200){
                if(response.data.code === 200){
                  if (this.active++ > 2) this.active = 0;
                }else{
                  this.captchaUrl = this.getCaptchaUrl();
                  this.$message.error({message:response.data.data[0] || `服务忙，请稍后再试`});
                }
              }else{
                this.captchaUrl = this.getCaptchaUrl();
                this.$message.error(`服务忙，请稍后再试`);
              }
            }).catch(error => {
              this.captchaUrl = this.getCaptchaUrl();
              this.submitButtonLoading = false;
            });
          } else {
            this.submitButtonLoading = false;
            return false;
          }
        });
      },
      goLogin() {
        this.submitButtonLoading = false;
        window.location.href = process.env.VUE_APP_API_URL
      }
    }
  }
</script>
<style>
  .el-divider--horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 12px 0;
  }
  .upload-left{
    text-align: left;
  }
  .register-wrapper-div{
    text-align: center;
    padding-top:10px;
    width: 750px;
    margin: 0 auto;
    background-color: #f8f8f8;
  }
</style>



// WEBPACK FOOTER //
// src/views/Forgot/ForgotPassword.vue